export interface DocumentTableThemeToken {
    blue1: string;
    blue4: string;
    borderRadiusLG: number;
    colorBgContainer: string;
    colorBorder: string;
    colorFillQuaternary: string;
    colorPrimary: string;
    colorText: string;
}

export interface DocumentTableTheme {
    background: string;
    border: string;
    borderRadius: number;
    headerBackground: string;
    headerText: string;
    selectedBackground: string;
    selectedGridColor: string;
    selectionBorder: string;
}

export const getDocumentTableTheme = (token: DocumentTableThemeToken): DocumentTableTheme => ({
    background: token.colorBgContainer,
    border: token.colorBorder,
    borderRadius: token.borderRadiusLG,
    headerBackground: token.colorFillQuaternary,
    headerText: token.colorText,
    selectedBackground: token.blue1,
    selectedGridColor: token.blue4,
    selectionBorder: token.colorPrimary,
});
